import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private apiUrl = 'api';
  // private apiUrl = 'https://avuoj7h3gg.execute-api.eu-west-2.amazonaws.com/UAT';
  // private apiUrl = 'http://localhost:3000';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  // Generic method for making GET requests
  get<T>(endpoint: string, params?: any): Observable<T> {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      source: 'web',
    });

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.get<T>(`${this.apiUrl}/${endpoint}`, {
      headers,
      params,
    });
  }

  // Generic method for making POST requests
  post<T>(
    endpoint: string,
    data: any,
    isBinary: boolean = false,
  ): Observable<T> {
    const token = this.authService.getAccessToken()?.toString();
    let headers: HttpHeaders;
    if (
      endpoint == 'auth/signin' ||
      endpoint == 'auth/set-password-first-login' ||
      endpoint == 'auth/forgot-password' ||
      endpoint == 'auth/confirm-password'
    ) {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
    } else {
      headers = new HttpHeaders({
        //auth: token,
        Authorization: `Bearer ${token}`,
        source: 'web',
      });
    }

    if (!isBinary && !(data instanceof FormData)) {
      headers = headers.set('Content-Type', 'application/json');
    }

    if (isBinary) {
      return this.http.post<T>(endpoint, data, {
        headers,
      });
    } else {
      return this.http.post<T>(`${this.apiUrl}/${endpoint}`, data, {
        headers,
        //responseType: isBinary ? 'json' : 'json'
      });
    }
  }

  postUpload<T>(endpoint: string, data: any): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, data);
  }

  postUploadExternal<T>(externalAPIURI: string, data: any): Observable<T> {
    return this.http.post<T>(`${externalAPIURI}`, data);
  }

  // Generic method for making PUT requests
  put<T>(endpoint: string, data: any): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${endpoint}`, data);
  }

  // Generic method for making DELETE requests
  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`);
  }

  bulkDelete<T>(endpoint: string, data: any): Observable<T> {
    const token = this.authService.getAccessToken()?.toString();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        auth: token,
        source: 'web',
      }),
      body: data,
    };
    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`, options);
  }
}
